import z from "zod";

// TODO: Add actual error types for Logging backend logic
const loggingErrorTypeValues = ["PLACEHOLDER_ERROR"] as const;

const loggingErrorTypeSchema = z.enum(loggingErrorTypeValues);
const LoggingErrorType = loggingErrorTypeSchema.enum;
type LoggingErrorType = z.infer<typeof loggingErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type LoggingErrors = {
  errorType: typeof LoggingErrorType.PLACEHOLDER_ERROR;
  // TODO: Add specific data fields for Logging errors
  data: Record<string, never>;
};

export const loggingErrorDetails: Record<LoggingErrorType, ErrorDetails> = {
  [LoggingErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Logging backend logic error",
  },
};
